
export const storage = [
  {
    name: 'Call Center',
    icon: 'icon icon-call-center',
  },
  {
    name: 'RV, Car, Boat Parking',
    icon: 'icon icon-rv-boat-parking',
  },
  {
    name: 'Se Habla Español',
    icon: 'icon icon-espanol',
  },
  {
    name: 'Wine Storage',
    icon: 'icon icon-wine-storage',
  },
  {
    name: 'Portable Storage',
    icon: 'icon icon-portable-storage',
  },
  {
    name: 'Business Center',
    icon: 'icon icon-business-center',
  },
  {
    name: 'Online Bill Pay',
    icon: 'icon icon-pay-online',
  },
  {
    name: 'Elevator Access',
    icon: 'icon icon-elevator-access',
  },
  {
    name: 'Near Campsites',
    icon: 'icon icon-near-campsites',
  },
  {
    name: 'Campsites-2',
    icon: 'icon icon-near-campsites-2',
  },
  {
    name: 'Campsites',
    icon: 'icon icon-rv-campsites',
  },
  {
    name: 'Interior Storage',
    icon: 'icon icon-interior-storage',
  },
  {
    name: 'Remote Control Entry',
    icon: 'icon icon-remote-control-entry',
  },
  {
    name: 'Restroom',
    icon: 'icon icon-restrooms-on-site',
  },
  {
    name: 'Wash Area',
    icon: 'icon icon-wash-area',
  },
  {
    name: 'Storage Calculator',
    icon: 'icon icon-cta-storage-calculator',
  },
  {
    name: 'Ramp',
    icon: 'icon icon-ramp',
  },
  {
    name: 'Uncovered',
    icon: 'icon icon-uncovered-parking',
  },
  {
    name: 'Ground Floor',
    icon: 'icon icon-ground-floor',
  },
  {
    name: 'Upstairs',
    icon: 'icon icon-upstairs',
  },
  {
    name: '24 Hour Kiosk',
    icon: 'icon icon-hour-kiosk',
  },
  {
    name: 'Resident Manager',
    icon: 'icon icon-resident-manager',
  },
  {
    name: 'Dollies/Handcarts',
    icon: 'icon icon-dollie-handcarts',
  },
  {
    name: 'Shipping Services',
    icon: 'icon icon-shipping-services',
  },
  {
    name: ' 24 hour Security',
    icon: 'icon icon-hour-security',
  },
  {
    name: 'Wide Roads',
    icon: 'icon icon-wide-roads',
  },
  {
    name: 'Light in Unit',
    icon: 'icon icon-power-in-unit',
  },
  {
    name: 'Boat',
    icon: 'icon icon-boat',
  },
  {
    name: 'Portable Storage 2',
    icon: 'icon icon-portable-storage2',
  },
  {
    name: 'Locations Map',
    icon: 'icon icon-locations-map',
  },
  {
    name: 'Locations Pin',
    icon: 'icon icon-locations-pin',
  },
  {
    name: 'CTA auctions',
    icon: 'icon icon-cta-auctions',
  },
  {
    name: 'Map Pin',
    icon: 'icon icon-primary-color-map-pin',
  },
  {
    name: 'Small',
    icon: 'icon icon-small',
  },
  {
    name: 'Medium',
    icon: 'icon icon-medium',
  },
  {
    name: 'Large',
    icon: 'icon icon-large',
  },
  {
    name: 'Vehicle',
    icon: 'icon icon-vehicle',
  },
  {
    name: '24 Hour Access by Request',
    icon: 'icon icon-24-hour-access-by-request',
  },
  {
    name: '24 Hour Access',
    icon: 'icon icon-24-hour-access',
  },
  {
    name: 'Ask About An Upgrade',
    icon: 'icon icon-ask-about-an-upgrade',
  },
  {
    name: 'Band Practice Space',
    icon: 'icon icon-band-practice-space',
  },
  {
    name: 'Bilingual Staff',
    icon: 'icon icon-bilingual-staff',
  },
  {
    name: 'Boxes and Moving Supplies',
    icon: 'icon icon-boxes-and-moving-supplies',
  },
  {
    name: 'Car Parking',
    icon: 'icon icon-car-parking',
  },
  {
    name: 'Clean',
    icon: 'icon icon-clean',
  },
  {
    name: 'Climate Control',
    icon: 'icon icon-climate-control',
  },
  {
    name: 'College Store',
    icon: 'icon icon-college-store',
  },
  {
    name: 'Convenient Location',
    icon: 'icon icon-convenient-location',
  },
  {
    name: 'Covered Loading Bay',
    icon: 'icon icon-covered-loading-bay',
  },
  {
    name: 'Covered Parking',
    icon: 'icon icon-covered-parking',
  },
  {
    name: 'Environmentally Friendly Space',
    icon: 'icon icon-environmentally-friendly-space',
  },
  {
    name: 'Excellent Rating',
    icon: 'icon icon-excellent-rating',
  },
  {
    name: 'Exclusive Online Discount',
    icon: 'icon icon-fenced',
  },
  {
    name: 'Free Moving Truck',
    icon: 'icon icon-free-moving-truck',
  },
  {
    name: 'Friendly',
    icon: 'icon icon-friendly',
  },
  {
    name: 'Fully Gated with Pin Access',
    icon: 'icon icon-fully-gated-with-pin-access',
  },
  {
    name: 'High Dock Access',
    icon: 'icon icon-high-dock-access',
  },
  {
    name: 'Loading Bay',
    icon: 'icon icon-loading-bay',
  },
  {
    name: 'Local Charity Sponsor',
    icon: 'icon icon-local-charity-sponsor',
  },
  {
    name: 'Low Monthly Rates',
    icon: 'icon icon-low-monthy-rates',
  },
  {
    name: 'Military Store',
    icon: 'icon icon-military-store',
  },
  {
    name: 'Month-to-Month Lease',
    icon: 'icon icon-month-to-month-lease',
  },
  {
    name: 'Moving Supplies Available',
    icon: 'icon icon-moving-supplies-available',
  },
  {
    name: 'Nearby Locations',
    icon: 'icon icon-nearby-locations',
  },
  {
    name: 'New Location',
    icon: 'icon icon-new-location',
  },
  {
    name: 'No Credit Card Required',
    icon: 'icon icon-no-credit-card-required',
  },
  {
    name: 'No Deposit Required',
    icon: 'icon icon-no-deposit-required',
  },
  {
    name: 'Now Hiring',
    icon: 'icon icon-now-hiring',
  },
  {
    name: 'On-Site Resident Manager',
    icon: 'icon icon-on-site-resident-manager',
  },
  {
    name: 'One Level',
    icon: 'icon icon-one-level',
  },
  {
    name: 'Onsite Parking Lot',
    icon: 'icon icon-onsite-parking-lot',
  },
  {
    name: 'PO Boxes',
    icon: 'icon icon-po-boxes',
  },
  {
    name: 'RV and Boat Parking',
    icon: 'icon icon-rv-and-boat-parking',
  },
  {
    name: 'Safe and Secure',
    icon: 'icon icon-safe-and-secure',
  },
  {
    name: 'Secured Keypad Access',
    icon: 'icon icon-secured-keypad-access',
  },
  {
    name: 'Security Cameras',
    icon: 'icon icon-security-cameras',
  },
  {
    name: 'Support English - (UK)',
    icon: 'icon icon-support-english-uk',
  },
  {
    name: 'Support English - (US)',
    icon: 'icon icon-support-english-us',
  },
  {
    name: 'Support English - (Canada)',
    icon: 'icon icon-support-french-canada',
  },
  {
    name: 'Support Spanish',
    icon: 'icon icon-support-spanish',
  },
  {
    name: 'Trust',
    icon: 'icon icon-trust',
  },
  {
    name: 'Unit Size Can Be Changed',
    icon: 'icon icon-unit-size-can-be-changed',
  },
  {
    name: 'Well Lit',
    icon: 'icon icon-well-lit',
  },
  {
    name: 'Wine Storage',
    icon: 'icon icon-wine-storage',
  },
  {
    name: 'Workshops',
    icon: 'icon icon-workshops',
  },
];

export const storageIconMap = {};
storage.forEach(({ name, icon }) => {
  storageIconMap[name] = icon;
});

export const storageNames = storage.map(({ name }) => name);
